/**
 * Sidebar component.
 */

/* eslint-disable no-inline-comments */
/* eslint-disable react/jsx-no-literals */
import './_sidebar.scss';
import { ApplicationContext } from '../../common/context';
import { FormattedMessage } from "react-intl";
import { Icon, Tooltip } from 'antd';
import React, { useContext } from 'react';

const SideBar = () => {
  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const tab = '2';
  const path = `${prefix}.${tab}`;

  const text1 = context.getOption(`${path}[1].text`);
  const text2 = context.getOption(`${path}[2].text`);
  const text3 = context.getOption(`${path}[3].text`);
  const text4 = context.getOption(`${path}[4].text`);
  const text5 = context.getOption(`${path}[5].text`);
  const text6 = context.getOption(`${path}[6].text`);

  const tooltip1 = context.getOption(`${path}[1].tooltip`);
  const tooltip2 = context.getOption(`${path}[2].tooltip`);
  const tooltip3 = context.getOption(`${path}[3].tooltip`);
  const tooltip4 = context.getOption(`${path}[4].tooltip`);
  const tooltip5 = context.getOption(`${path}[5].tooltip`);
  const tooltip6 = context.getOption(`${path}[6].tooltip`);

  return (
    <div className={'sidebar'}>
      <div className={'sidebar__header'}>
        <h3 className={'sidebar__header-title'}>
          <FormattedMessage id="sidebar.name"/>
        </h3>
        {context.isMatrix ? null : <h3 className={'sidebar__header-subtitle'}> <FormattedMessage id="sidebar.invest"/> </h3>}
      </div>

      <h2 className={'sidebar__main-question'}>{context.getOption(`${path}.1.title`)}</h2>

      <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.1.subtitle`)}</h3>

      {text1.map((text, index) =>
        (
          <p
            className={'sidebar__question'}
            key={index}
          >
            {text}
            {context.isEvaluation ? null : <Tooltip
              arrowPointAtCenter
              placement={'top'}
              title={tooltip1[index]}
            >
              <Icon type={'info-circle'} />
            </Tooltip>
            }
          </p>
        )
      )}

      {context.isMatrix ? <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.2.subtitle`)}</h3> : <div className={'sidebar__spacer--one'} />
      }

      {text2.map((text, index) =>
        (
          <p
            className={'sidebar__question'}
            key={index}
          >
            {text}
            {context.isEvaluation ? null : <Tooltip
              arrowPointAtCenter
              placement={'top'}
              title={tooltip2[index]}
            >
              <Icon type={'info-circle'} />
            </Tooltip>
            }

          </p>
        ))}

      {/* Section3 */}
      <h2 className={'sidebar__main-question sidebar__main-question--evaluation-no-question'}>{context.getOption(`${path}.3.title`)}</h2>

      <div className={'sidebar__question-wrap'}>
        <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.3.subtitle`)}</h3>

        {text3.map((text, index) =>
          (
            <p
              className={'sidebar__question'}
              key={index}
            >
              {text}
              {context.isEvaluation ? null : <Tooltip
                arrowPointAtCenter
                placement={'top'}
                title={tooltip3[index]}
              >
                <Icon type={'info-circle'} />
              </Tooltip>
              }
            </p>
          )
        )}
      </div>

      <div className={'sidebar__question-wrap1'}>
        {context.isMatrix ? <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.4.subtitle`)}</h3> : <div className={'sidebar__spacer--one'} />}

        {text4.map((text, index) =>
          (
            <p
              className={'sidebar__question'}
              key={index}
            >
              {text}
              {context.isEvaluation ? null : <Tooltip
                arrowPointAtCenter
                placement={'top'}
                title={tooltip4[index]}
              >
                <Icon type={'info-circle'} />
              </Tooltip>
              }
            </p>
          ))}

        {/* Section3 */}
        <h2 className={'sidebar__main-question sidebar__main-question--evaluation-no-question page-break-before'}>{context.getOption(`${path}.5.title`)}</h2>

        <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.5.subtitle`)}</h3>

        {text5.map((text, index) =>
          (
            <p
              className={'sidebar__question'}
              key={index}
            >
              {text}
              {context.isEvaluation ? null : <Tooltip
                arrowPointAtCenter
                placement={'top'}
                title={tooltip5[index]}
              >
                <Icon type={'info-circle'} />
              </Tooltip>
              }
            </p>
          )
        )}

        <h3 className={'sidebar__sub-question'}>{context.getOption(`${path}.6.subtitle`)}</h3>

        {text6.map((text, index) =>
          (
            <p
              className={'sidebar__question'}
              key={index}
            >
              {text}
              {context.isEvaluation ? null : <Tooltip
                arrowPointAtCenter
                placement={'top'}
                title={tooltip6[index]}
              >
                <Icon type={'info-circle'} />
              </Tooltip>
              }
            </p>
          ))}
      </div>
    </div>
  );
};

export default SideBar;
